export default "__VITE_ASSET__6456808e__"